import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setTitle } from 'Store/Organization/Title/TitleAction';
import { GET_TITLE } from 'Store/Organization/Title/TitleType';
import OrganizationApiService from './OrganizationApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getTitle(): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown Data...."));
        let payloadData : IPayload = {
            apiType : apiType.Organization,
            endpoint : 'organizations/dropdown/titles',
            apiMethod :  apiMethod.GET,
            payload : null
            
        }
        const response = yield call(
            OrganizationApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setTitle(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* watchGetStates() {
    yield takeEvery(GET_TITLE, getTitle)
}

export default function* combinedSaga() {
    yield all([
        watchGetStates()
    ])
}
